<section class="projects" id="projects">
  <div class="projects__content">
    <h2>{{ 'PROJECTS.TITLE' | translate }}</h2>

    <div class="projects__grid">
      <div class="project" *ngFor="let i of [0,1,2,3]">
        <h3>{{ ('PROJECTS.LIST.' + i + '.TITLE') | translate }}</h3>
        <p [innerHTML]="('PROJECTS.LIST.' + i + '.TEXT') | translate"></p>
      </div>
    </div>
  </div>
</section>
